import { jsxs as l, jsx as c } from "react/jsx-runtime";
const p = ({ size: a = 16, ...h }) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: a,
    height: a,
    viewBox: "0 0 38 24",
    fill: "none",
    ...h,
    children: [
      /* @__PURE__ */ l("g", { clipPath: "url(#clip0_1476_47388)", children: [
        /* @__PURE__ */ c(
          "path",
          {
            fill: "color(display-p3 0.3529 0.1922 0.9569)",
            d: "M35 0H3C1.3 0 0 1.3 0 3v18c0 1.7 1.4 3 3 3h32c1.7 0 3-1.3 3-3V3c0-1.7-1.4-3-3-3z"
          }
        ),
        /* @__PURE__ */ c(
          "path",
          {
            fill: "color(display-p3 0.3529 0.1922 0.9569)",
            d: "M35 1c1.1 0 2 .9 2 2v18c0 1.1-.9 2-2 2H3c-1.1 0-2-.9-2-2V3c0-1.1.9-2 2-2h32z"
          }
        ),
        /* @__PURE__ */ c("g", { fill: "#fff", clipPath: "url(#clip1_1476_47388)", children: /* @__PURE__ */ c("path", { d: "M9.858 11.398c-.964-.212-1.394-.295-1.394-.672 0-.354.291-.53.873-.53.511 0 .885.226 1.16.67.021.034.064.046.099.028l1.085-.556a.078.078 0 00.031-.108c-.45-.792-1.282-1.225-2.378-1.225-1.44 0-2.334.72-2.334 1.862 0 1.215 1.09 1.522 2.055 1.734.966.212 1.397.295 1.397.671 0 .377-.314.555-.941.555-.58 0-1.009-.269-1.269-.79a.076.076 0 00-.102-.035l-1.083.544a.079.079 0 00-.034.106c.43.876 1.311 1.368 2.489 1.368 1.5 0 2.405-.707 2.405-1.886 0-1.179-1.094-1.521-2.059-1.733v-.003zM15.673 9.005c-.616 0-1.16.221-1.55.615a.038.038 0 01-.065-.028V7.078A.076.076 0 0013.98 7h-1.357a.076.076 0 00-.077.078v7.804c0 .043.034.078.076.078h1.358a.076.076 0 00.077-.078v-3.423c0-.662.5-1.169 1.173-1.169.674 0 1.162.497 1.162 1.169v3.423c0 .043.034.078.077.078h1.358a.077.077 0 00.076-.078v-3.423c0-1.439-.93-2.454-2.231-2.454zM20.662 8.781a3.54 3.54 0 00-1.924.56.078.078 0 00-.025.104l.598 1.037c.023.037.07.05.106.027.376-.23.807-.35 1.247-.347 1.185 0 2.056.848 2.056 1.969 0 .955-.697 1.662-1.58 1.662-.721 0-1.221-.425-1.221-1.026 0-.344.144-.626.52-.824a.077.077 0 00.029-.108l-.565-.97a.076.076 0 00-.092-.033c-.757.285-1.288.97-1.288 1.889 0 1.39 1.092 2.429 2.615 2.429 1.778 0 3.057-1.25 3.057-3.043 0-1.922-1.488-3.326-3.534-3.326zM28.165 8.993c-.687 0-1.301.258-1.75.711-.024.025-.064.007-.064-.027V9.13a.077.077 0 00-.077-.077h-1.322a.077.077 0 00-.077.077v7.793c0 .043.034.078.077.078h1.357a.076.076 0 00.077-.078v-2.555c0-.035.04-.052.065-.03a2.456 2.456 0 001.713.668C29.758 15.007 31 13.7 31 12s-1.244-3.007-2.835-3.007zm-.258 4.695c-.906 0-1.592-.732-1.592-1.698 0-.967.685-1.698 1.592-1.698.908 0 1.592.72 1.592 1.698s-.675 1.698-1.593 1.698h.002z" }) })
      ] }),
      /* @__PURE__ */ l("defs", { children: [
        /* @__PURE__ */ c("clipPath", { id: "clip0_1476_47388", children: /* @__PURE__ */ c("path", { fill: "#fff", d: "M0 0H38V24H0z" }) }),
        /* @__PURE__ */ c("clipPath", { id: "clip1_1476_47388", children: /* @__PURE__ */ c("path", { fill: "#fff", d: "M0 0H24V10H0z", transform: "translate(7 7)" }) })
      ] })
    ]
  }
);
export {
  p as ShopPayIcon
};
